module.exports = __webpack_public_path__ + "img/party_cloudy_night.54fd9400.svg";